<section
  class="bg-myportal-three min-h-[calc(100vh-220px)] bg-top bg-no-repeat"
>
  <div class="mx-auto w-full max-w-7xl p-5 md:px-8">
    <h1 class="pb-4 text-3xl font-light text-white">Orders Summary</h1>

    @if (loadingAllPage) {
      <div class="loading-spinner">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    } @else {
      <div class="summary">
        <mat-grid-list
          class="dashboard-grid m-0 tile-overflow-visible"
          [cols]="breakpoint"
          gutterSize="10px"
          rowHeight="100px"
          (window:resize)="onResize($event)"
        >
          <mat-grid-tile class="tile-widget !overflow-visible" rowspan="5">
            <app-service-overview
              title="Service Overview"
              [list]="serviceOverviewList"
              [loading]="loading"
              extraClass="overview"
              (navigate)="navigate($event)"
            ></app-service-overview>
          </mat-grid-tile>

          <mat-grid-tile
            class="tile-widget bullet-row h-32 !overflow-visible"
            height="120px"
          >
            <app-bullet-status
              bulletClass="preparing-order-vendor"
              title="Preparing Order for Vendor"
              [value]="countPreparing"
              [loading]="loading"
            ></app-bullet-status>
          </mat-grid-tile>
          <mat-grid-tile class="tile-widget bullet-row h-32 !overflow-visible">
            <app-bullet-status
              bulletClass="count-implementation"
              title="Implementation"
              [value]="countImplementation"
              [loading]="loading"
            ></app-bullet-status>
          </mat-grid-tile>
          <mat-grid-tile class="tile-widget bullet-row h-32 !overflow-visible">
            <app-bullet-status
              bulletClass="count-installed"
              title="Installed"
              [value]="countInService"
              [loading]="loading"
            ></app-bullet-status>
          </mat-grid-tile>

          <mat-grid-tile
            class="tile-widget !overflow-visible"
            [colspan]="breakpoint > 1 ? 3 : 1"
            rowspan="4"
          >
            <app-circuit-milestones
              [data]="milestonesData"
              [loading]="milestonesDataLoading"
              (navigate)="navigate($event)"
            ></app-circuit-milestones>
          </mat-grid-tile>

          <mat-grid-tile class="tile-widget !overflow-visible" rowspan="3">
            <app-service-overview
              title="Activation Status"
              [list]="startOfServiceList"
              [loading]="loading"
              extraClass="bottom"
              (navigate)="navigate($event)"
            ></app-service-overview>
          </mat-grid-tile>
          <mat-grid-tile class="tile-widget !overflow-visible" rowspan="3">
            <app-service-overview
              title="In-progress Services"
              emptyMessage="There are currently no in-flight orders"
              [list]="inFlightServiceList"
              [loading]="inFlightServiceLoading"
              extraClass="bottom scroll"
              (navigate)="navigate($event)"
            ></app-service-overview>
          </mat-grid-tile>
          <mat-grid-tile
            class="tile-widget !overflow-visible"
            rowspan="3"
            [colspan]="breakpoint > 1 ? 2 : 1"
          >
            <app-pending-foc-dates
              [data]="pendingFocDateList"
              [total]="pendingFocDateTotal"
              [loading]="pendingFocDateLoading"
              (navigate)="navigate($event)"
            ></app-pending-foc-dates>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    }
  </div>
</section>
